import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const TrashIcon = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 15.85938 21.58789" width={size} height={size}>
      <title>{iconTitle}</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="trash" data-name="Layer 3" fill={iconColor}>
          <path d="M13.40723,5.21289a.75019.75019,0,0,0-.75.75V19.93066a.15713.15713,0,0,1-.15723.15723H3.35938a.15754.15754,0,0,1-.15772-.15723V5.96289a.75.75,0,1,0-1.5,0V19.93066a1.65918,1.65918,0,0,0,1.65772,1.65723H12.5a1.65877,1.65877,0,0,0,1.65723-1.65723V5.96289A.7502.7502,0,0,0,13.40723,5.21289Z" />
          <path d="M15.10938,3.24707H11.30957v-.9624A2.28684,2.28684,0,0,0,9.02539,0H6.834A2.28726,2.28726,0,0,0,4.54932,2.28467v.9624H.75a.75.75,0,0,0,0,1.5H15.10938a.75.75,0,0,0,0-1.5Zm-9.06006-.9624A.78562.78562,0,0,1,6.834,1.5H9.02539a.7852.7852,0,0,1,.78418.78467v.9624H6.04932Z" />
          <path d="M10.67969,16.64941V7.43555a.75.75,0,1,0-1.5,0v9.21386a.75.75,0,0,0,1.5,0Z" />
          <path d="M6.67969,16.64941V7.43555a.75.75,0,0,0-1.5,0v9.21386a.75.75,0,0,0,1.5,0Z" />
        </g>
      </g>
    </svg>
  );
};

TrashIcon.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

TrashIcon.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(TrashIcon);
